








































































































































































































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import SaleOrderRequestDetail from "../../../store/entities/sale-order-request/sale-order-request-detail";
import SaleOrderRequestLine from "../../../store/entities/sale-order-request/sale-order-request-line";
import Barcode from "../../components/bar-code.vue";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import AppConsts from "../../../lib/appconst";
import _ from "lodash";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import CreateSalesOrderModal from "../sale-order/modal-create-sales-order.vue";
import NoteModal from "../../components/note-modal.vue";
import moment from "moment";

class PageSORRequestLineRequest extends PageRequest {
  keyword: string;
}
class PageSORRequestLineGiftRequest extends PageRequest {
  keyword: string;
}
class PageSaleOrderRequest extends PageRequest {
  keyword: string;
  clientCode: string;
  status: string;
  warehouseCode: string;
  from: Date;
  to: Date;
  soRequestId: number;
}
class PageDeliveryNoteRequest extends PageRequest {
  keyword: string;
  status: string;
  fromDate: Date;
  toDate: Date;
  soRequestId: number;
}
@Component({
  components: {
    "bar-code": Barcode,
    "create-sales-order": CreateSalesOrderModal,
    "note-modal": NoteModal,
  },
})
export default class ViewSaleOrderRequest extends mixins(
  ListMixin,
  DateTimeMixin,
  AbpBase
) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  createSalesOrderText = AppConsts.permissionNames.createSalesOrder;
  namespace = "saleOrder";
  sorNamespace = "saleOrderRequest";
  linepageRequest: PageSORRequestLineRequest = new PageSORRequestLineRequest();
  giftpageRequest: PageSORRequestLineGiftRequest = new PageSORRequestLineGiftRequest();
  pagerequest: PageSaleOrderRequest = new PageSaleOrderRequest();
  saleOrderRequest: SaleOrderRequestDetail = new SaleOrderRequestDetail();
  saleOrderRequestLines: Array<SaleOrderRequestLine> = new Array<
    SaleOrderRequestLine
  >();
  sorLineList: Array<SaleOrderRequestLine> = new Array<SaleOrderRequestLine>();
  sorLineGiftList: Array<SaleOrderRequestLine> = new Array<
    SaleOrderRequestLine
  >();
  sorLinePageList: Array<SaleOrderRequestLine> = new Array<
    SaleOrderRequestLine
  >();
  sorLineGiftPageList: Array<SaleOrderRequestLine> = new Array<
    SaleOrderRequestLine
  >();
  sorHistoryList: Array<any> = new Array<any>();
  sorHistoryPageList: Array<any> = new Array<any>();
  soStatuses = [];
  warehouses = [];
  spinShow: boolean = false;
  code: string = "";
  id: number = 0;
  creationTime: Date[] = [];
  //======== delivery notes
  deliveryNoteNamespace = "deliveryNote";

  deliveryNoteStatuses = _.get(
    Util.abp["custom"],
    ["wms.DeliveryNote", "StatusCode"],
    []
  );
  deliveryNoteCreationTime: Date[] = [];
  deliveryNoteStatusPrefix = AppConsts.tableRef.tableDeliveryNote.prefix.status;
  validReturnDeliveryNoteStatusArr = [AppConsts.deliveryNoteStatus.finished];
  deliveryNotePageRequest: PageDeliveryNoteRequest = new PageDeliveryNoteRequest();
  isSearchPreorder: boolean = false;
  //=======================
  validCancelSORStatusArr = [
    AppConsts.sorStatus.draft,
    AppConsts.sorStatus.preview,
    AppConsts.sorStatus.preOrder,
    AppConsts.sorStatus.approved,
    AppConsts.sorStatus.processing,
  ];
  validRejectSORStatusArr = [
    AppConsts.sorStatus.preOrder,
    AppConsts.sorStatus.approved,
    AppConsts.sorStatus.processing,
  ];
  validFinishSORStatusArr = [
    // AppConsts.sorStatus.approved,
    AppConsts.sorStatus.processing,
  ];
  statusPrefix = AppConsts.tableRef.tableSOR.prefix.status;
  createSalesOrderModalShow = false;
  cancelNote: string = "";
  cancelNoteModalShow: boolean = false;
  note: string = "";
  rejectNoteModalShow: boolean = false;
  get store() {
    return this.$store.state.saleOrder;
  }
  get sorStore() {
    return this.$store.state.saleOrderRequest;
  }
  get deliveryNoteStore() {
    return this.$store.state.deliveryNote;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  async getStatuses() {
    await this.$store
      .dispatch({
        type: "saleOrder/getSoStatusesForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        var re = this.store.soStatuses;
        this.pagerequest.status = re.length === 0 ? "" : re[0].code;
        this.soStatuses = re;
      });
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        if (!this.isTenant())
          this.pagerequest.warehouseCode = re.length === 0 ? "" : re[0].id;
        this.warehouses = re;
      });
  }
  //============sales orders page =================
  get loading() {
    return this.store.loading;
  }
  preGetPage() {
    this.pagerequest.soRequestId = this.id;
    if (this.isClient()) {
      this.pagerequest.clientCode = this.client.code;
    }
    if (this.isTenant()) {
      this.pagerequest.warehouseCode = this.tenant.tenancyName;
    }
    if (this.creationTime.length > 0) {
      this.pagerequest.from = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.to = this.creationTime[1];
    }
  }
  get soList() {
    var re = this.store.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }

  //============Gift page =================
  get sumGiftOrderQty() {
    return _.sumBy(this.sorLineGiftPageList, function(o) {
      return o.qty;
    });
  }
  get sumGiftHandoverQty() {
    return _.sumBy(this.sorLineGiftPageList, function(o) {
      return o.handoverQty;
    });
  }
  get sumGiftSoQty() {
    return _.sumBy(this.sorLineGiftPageList, function(o) {
      return o.soQty;
    });
  }
  get lineGiftLoading() {
    return this.sorStore.lineGiftLoading;
  }
  get lineGiftPageSize() {
    return this.sorStore.lineGiftPageSize;
  }
  get lineGiftTotalCount() {
    return this.sorStore.lineGiftTotalCount;
  }
  get lineGiftCurrentPage() {
    return this.sorStore.lineGiftCurrentPage;
  }
  refreshGiftPageIndex() {
    this.$store.commit(`${this.sorNamespace}/setGiftCurrentPage`, 1);
  }
  lineGiftPageChange(page: number) {
    this.$store.commit(`${this.sorNamespace}/setGiftCurrentPage`, page);
    this.getGiftPage();
  }
  lineGiftPageSizeChange(pagesize: number) {
    this.$store.commit(`${this.sorNamespace}/setGiftPageSize`, pagesize);
    this.getGiftPage();
  }
  async searchGiftData() {
    this.refreshGiftPageIndex();
    await this.getGiftPage();
  }
  async getGiftPage() {
    var list = this.sorLineGiftList;
    if (
      !_.isNil(this.giftpageRequest.keyword) &&
      !_.isEmpty(this.giftpageRequest.keyword)
    ) {
      var keyWord = this.giftpageRequest.keyword.toUpperCase();
      list = _.filter(this.sorLineGiftList, function(o) {
        return (
          o.product.sku.toUpperCase().indexOf(keyWord) >= 0 ||
          o.product.sku.toUpperCase().indexOf(keyWord) >= 0
        );
      });
    }
    this.$store.commit(
      `${this.sorNamespace}/setGiftTotalCount`,
      _.isNil(list) ? 0 : list.length
    );

    this.sorLineGiftPageList = Util.pagingItems(
      list,
      this.lineGiftPageSize,
      this.lineGiftCurrentPage
    );
  }
  //============line page =================
  get sumLineOrderQty() {
    return _.sumBy(this.sorLinePageList, function(o) {
      return o.qty;
    });
  }
  get sumLineHandoverQty() {
    return _.sumBy(this.sorLinePageList, function(o) {
      return o.handoverQty;
    });
  }
  get sumVolumeM3() {
    return _.sumBy(this.sorLinePageList, function(o) {
      return o.product.volumeM3 * o.qty;
    });
  }
  get sumLineSoQty() {
    return _.sumBy(this.sorLinePageList, function(o) {
      return o.soQty;
    });
  }
  get lineLoading() {
    return this.sorStore.lineLoading;
  }
  get linePageSize() {
    return this.sorStore.linePageSize;
  }
  get lineTotalCount() {
    return this.sorStore.lineTotalCount;
  }
  get lineCurrentPage() {
    return this.sorStore.lineCurrentPage;
  }
  refreshLinePageIndex() {
    this.$store.commit(`${this.sorNamespace}/setLineCurrentPage`, 1);
  }
  linePageChange(page: number) {
    this.$store.commit(`${this.sorNamespace}/setLineCurrentPage`, page);
    this.getLinePage();
  }
  linePageSizeChange(pagesize: number) {
    this.$store.commit(`${this.sorNamespace}/setLinePageSize`, pagesize);
    this.getLinePage();
  }
  async searchLineData() {
    this.refreshLinePageIndex();
    await this.getLinePage();
  }
  async getLinePage() {
    var list = this.sorLineList;
    var isPreorder = this.isSearchPreorder;
    if (isPreorder)
      list = _.filter(this.sorLineList, function(o) {
        return o.qty > o.availableQty;
      });

    if (
      !_.isNil(this.linepageRequest.keyword) &&
      !_.isEmpty(this.linepageRequest.keyword)
    ) {
      var keyWord = this.linepageRequest.keyword.toUpperCase();
      list = _.filter(this.sorLineList, function(o) {
        return (
          o.product.sku.toUpperCase().indexOf(keyWord) >= 0 ||
          o.product.sku.toUpperCase().indexOf(keyWord) >= 0
        );
      });
    }
    this.$store.commit(
      `${this.sorNamespace}/setLineTotalCount`,
      _.isNil(list) ? 0 : list.length
    );
    this.sorLinePageList = Util.pagingItems(
      list,
      this.linePageSize,
      this.lineCurrentPage
    );
  }
  //============history page =================
  get histories() {
    var re = this.sorHistoryPageList;
    var startIndex = (this.historyCurrentPage - 1) * this.historyPageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  get historyLoading() {
    return this.sorStore.historyLoading;
  }
  get historyPageSize() {
    return this.sorStore.historyPageSize;
  }
  get historyTotalCount() {
    return this.sorStore.historyTotalCount;
  }
  get historyCurrentPage() {
    return this.sorStore.historyCurrentPage;
  }
  refreshHistoryPageIndex() {
    this.$store.commit(`${this.sorNamespace}/setHistoryCurrentPage`, 1);
  }
  historyPageChange(page: number) {
    this.$store.commit(`${this.sorNamespace}/setHistoryCurrentPage`, page);
    this.getHistoryPage();
  }
  historyPageSizeChange(pagesize: number) {
    this.$store.commit(`${this.sorNamespace}/setHistoryPageSize`, pagesize);
    this.getHistoryPage();
  }
  async searchHistoryData() {
    this.refreshHistoryPageIndex();
    await this.getHistoryPage();
  }
  async getHistoryPage() {
    var list = this.sorHistoryList;

    this.$store.commit(
      `${this.sorNamespace}/setHistoryTotalCount`,
      _.isNil(list) ? 0 : list.length
    );
    this.sorHistoryPageList = Util.pagingItems(
      list,
      this.historyPageSize,
      this.historyCurrentPage
    );
  }
  async getHistories() {
    this.$store
      .dispatch({
        type: "saleOrderRequest/getHistories",
        data: { id: this.id },
      })
      .then(async (result) => {
        this.sorHistoryList = result;
        this.getHistoryPage();
      });
  }
  //============delivery Notes page =================
  canReturnDeliveryNote(statusCode) {
    if (
      this.validReturnDeliveryNoteStatusArr.includes(statusCode) &&
      this.hasPermission(AppConsts.permissionNames.returnDeliveryNote) &&
      this.isTenant()
    ) {
      return true;
    }
    return false;
  }
  async returnDeliveryNote(row) {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.ReturnDeliveryNote"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        this.$store
          .dispatch({
            type: `${this.deliveryNoteNamespace}/return`,
            data: {
              id: row.id,
            },
          })
          .then(async () => {
            Util.showSuccessMsg(this, "Success.ReturnDeliveryNote");
            this.searchDeliveryNoteData();
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
  get deliveryNoteLoading() {
    return this.deliveryNoteStore.loading;
  }
  get deliveryNotePageSize() {
    return this.deliveryNoteStore.pageSize;
  }
  get deliveryNoteTotalCount() {
    return this.deliveryNoteStore.totalCount;
  }
  get deliveryNoteCurrentPage() {
    return this.deliveryNoteStore.currentPage;
  }
  refreshDeliveryNotePageIndex() {
    this.$store.commit(`${this.deliveryNoteNamespace}/setCurrentPage`, 1);
  }
  deliveryNotePageChange(page: number) {
    this.$store.commit(`${this.deliveryNoteNamespace}/setCurrentPage`, page);
    this.getDeliveryNotePage();
  }
  deliveryNotePageSizeChange(pagesize: number) {
    this.$store.commit(`${this.deliveryNoteNamespace}/setPageSize`, pagesize);
    this.getDeliveryNotePage();
  }
  async searchDeliveryNoteData() {
    this.refreshDeliveryNotePageIndex();
    await this.getDeliveryNotePage();
  }
  async getDeliveryNotePage() {
    this.deliveryNotePreGetPage();
    await this.$store
      .dispatch({
        type: `${this.deliveryNoteNamespace}/getAll`,
        data: this.deliveryNotePageRequest,
      })
      .catch(() => {
        this.deliveryNoteStore.loading = false;
      });
  }
  deliveryNotePreGetPage() {
    this.deliveryNotePageRequest.fromDate = null;
    this.deliveryNotePageRequest.toDate = null;
    this.deliveryNotePageRequest.soRequestId = this.id;
    this.deliveryNotePageRequest.maxResultCount = this.deliveryNotePageSize;
    this.deliveryNotePageRequest.skipCount =
      (this.deliveryNoteCurrentPage - 1) * this.deliveryNotePageSize;
    if (
      this.deliveryNoteCreationTime.length > 0 &&
      !_.isNil(this.deliveryNoteCreationTime[0]) &&
      this.deliveryNoteCreationTime[0].toString() !== ""
    ) {
      this.deliveryNotePageRequest.fromDate = moment(
        this.deliveryNoteCreationTime[0]
      )
        .startOf("d")
        .toDate();
    }
    if (
      this.deliveryNoteCreationTime.length > 1 &&
      !_.isNil(this.deliveryNoteCreationTime[1]) &&
      this.deliveryNoteCreationTime[1].toString() !== ""
    ) {
      this.deliveryNotePageRequest.toDate = moment(
        this.deliveryNoteCreationTime[1]
      )
        .endOf("d")
        .toDate();
    }
  }
  get deliveryNoteList() {
    var re = this.deliveryNoteStore.list;
    var startIndex =
      (this.deliveryNoteCurrentPage - 1) * this.deliveryNotePageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  //======= cancel
  isCanceldSalesOrderRequest() {
    return this.saleOrderRequest.statusCode === AppConsts.sorStatus.canceled;
  }

  canCancel() {
    return this.validCancelSORStatusArr.includes(
      this.saleOrderRequest.statusCode
    );
  }
  canCancelSor() {
    if (
      this.canCancel() &&
      this.hasPermission(AppConsts.permissionNames.cancelSalesOrderRequest) &&
      this.isClient()
    ) {
      return true;
    }
    return false;
  }
  openCancelNoteModal() {
    this.cancelNote = "";
    this.cancelNoteModalShow = true;
  }
  cancelSalesOrderRequest() {
    if (Util.isEmpty(this.cancelNote)) {
      Util.showErrorMsg(this, "Error.CancelNoteIsRequired");
      return;
    }
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.CancelSalesOrderRequest"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        this.$store
          .dispatch({
            type: "saleOrderRequest/cancel",
            data: {
              id: this.saleOrderRequest.id,
              note: this.cancelNote,
            },
          })
          .then(async () => {
            await this.getSalesOrderRequest();
            Util.showSuccessMsg(this, "Success.CancelSalesOrderRequest");
            this.cancelNote = "";
            this.cancelNoteModalShow = false;
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
  //======= Reject ===========
  canRejectSor() {
    if (
      this.validRejectSORStatusArr.includes(this.saleOrderRequest.statusCode) &&
      this.hasPermission(AppConsts.permissionNames.rejectSalesOrderRequest) &&
      this.saleOrderRequest.inputChannelCode === AppConsts.inputChannel.API_CRM &&
      this.isTenant()
    ) {
      return true;
    }
    return false;
  }
  openRejectNoteModal() {
    this.note = "";
    this.rejectNoteModalShow = true;
  }
  rejectSalesOrderRequest() {
    if (Util.isEmpty(this.note)) {
      Util.showErrorMsg(this, "Error.RejectNoteIsRequired");
      return;
    }
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.RejectSalesOrderRequest"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        this.$store
          .dispatch({
            type: "saleOrderRequest/reject",
            data: {
              id: this.saleOrderRequest.id,
              note: this.note,
            },
          })
          .then(async () => {
            await this.getSalesOrderRequest();
            Util.showSuccessMsg(this, "Success.RejectSalesOrderRequest");
            this.note = "";
            this.rejectNoteModalShow = false;
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
  //======= Finish ===========
  canFinishSor() {
    if (
      this.validFinishSORStatusArr.includes(this.saleOrderRequest.statusCode) &&
      this.hasPermission(AppConsts.permissionNames.finishSalesOrderRequest)
    ) {
      return true;
    }
    return false;
  }
  finishSalesOrderRequest() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.FinishSalesOrderRequest"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        this.$store
          .dispatch({
            type: "saleOrderRequest/finish",
            data: {
              id: this.saleOrderRequest.id,
            },
          })
          .then(async () => {
            await this.getSalesOrderRequest();
            Util.showSuccessMsg(this, "Success.FinishSalesOrderRequest");
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
  //========== create Sales order
  canCreateSalesOrder() {
    if (
      (this.saleOrderRequest.statusCode === AppConsts.sorStatus.approved ||
        this.saleOrderRequest.statusCode == AppConsts.sorStatus.processing) &&
      this.hasPermission(AppConsts.permissionNames.createSalesOrder) 
      // && this.saleOrderRequest.inputChannelCode !== AppConsts.inputChannel.API_CRM
    ) {
      return true;
    }
    return false;
  }
  openCreateSalesOrderModal() {
    this.createSalesOrderModalShow = true;
  }

  async closeCreateSalesOrderModal() {
    this.createSalesOrderModalShow = false;
    await this.getSalesOrderRequest();
  }
  //======= Recheck
  hasRecheckPermission() {
    return (
      this.hasPermission(AppConsts.permissionNames.recheckPreOrders) &&
      this.saleOrderRequest.statusCode == AppConsts.sorStatus.approved &&
      this.userCanRecheckPermission()
    );
  }
  userCanRecheckPermission() {
    return (
      this.isClient() ||
      (this.isTenant() 
      // &&
      //   !_.isNil(this.saleOrderRequest.processWarehouseCode) &&
      //   !_.isEmpty(this.saleOrderRequest.processWarehouseCode) &&
      //   this.saleOrderRequest.processWarehouseCode === this.tenant.tenancyName
      )
    );
  }
  recheck() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.RecheckSalesOrderRequest"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        await this.$store
          .dispatch({
            type: "saleOrderRequest/recheck",
            data: {
              id: this.saleOrderRequest.id,
            },
          })
          .then(async () => {
            await this.getSalesOrderRequest();
            Util.showSuccessMsg(this, "Success.RecheckSalesOrderRequest");
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
  //======== functions ===========
  cancel() {
    this.$emit("input", false);
    this.$root.$router.push({ name: "saleorder-request" });
  }
  async getSalesOrderRequest() {
    await this.$store
      .dispatch({
        type: "saleOrderRequest/get",
        data: { id: this.id },
      })
      .then(async (result) => {
        this.saleOrderRequest = result;
        this.id = this.saleOrderRequest.id;
        this.code = this.saleOrderRequest.code;
        this.saleOrderRequestLines = this.saleOrderRequest.lines;
        this.sorHistoryList = this.saleOrderRequest.histories;
        this.buildSalesOrderRequestLines(this.saleOrderRequest.lines);
        await this.getHistories();
      });
  }
  async refreshSalesOrderRequestLines() {
    this.$store.commit(`${this.sorNamespace}/setLineLoading`, true);
    await this.$store
      .dispatch({
        type: "saleOrderRequest/getSORLines",
        data: { id: this.id },
      })
      .then(async (result) => {
        this.saleOrderRequestLines = result;
        this.buildSalesOrderRequestLines(result);
      });
    this.$store.commit(`${this.sorNamespace}/setLineLoading`, false);
  }
  buildSalesOrderRequestLines(lines) {
    this.sorLineList = _.filter(lines, function(o) {
      return o.isGift === false;
    });
    this.sorLineGiftList = _.filter(lines, function(o) {
      return o.isGift === true;
    });
    this.searchLineData();
    this.searchGiftData();
  }
  async created() {
    this.spinShow = true;
    try {
      this.id = +this.$root.$router.currentRoute.params.id;
      await this.getSalesOrderRequest();
      await this.getStatuses();
      if (this.isClient) await this.getWarehouses();
      this.deliveryNoteCreationTime = Util.buildDefaultViewDate(7);
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
  renderLineColumn() {
    if (this.isClient()) {
      return [
        {
          title: Util.L("Warehouse"),
          width: 120,
          key: "warehouseCode",
          render: (h: any, params: any) => {
            if (_.isNil(params.row.warehouse))
              return h("span", params.row.warehouseCode);
            return h(
              "span",
              `${params.row.warehouse.id} - ${params.row.warehouse.name}`
            );
          },
        },
      ];
    }
    return [];
  }
  get giftColumns() {
    return [
      ...this.renderLineColumn(),
      {
        title: Util.L("Sku"),
        width: 150,
        key: "product.sku",
        render: (h: any, params: any) => {
          return h("span", params.row.product.sku);
        },
      },
      {
        title: Util.L("ProductName"),
        width: 250,
        key: "product.name",
        render: (h: any, params: any) => {
          return h("span", params.row.product.name);
        },
      },
      {
        title: Util.L("Unit"),
        width: 150,
        key: "product.productUnit.name",
        render: (h: any, params: any) => {
          return h("span", params.row.product.productUnit.name);
        },
      },
      {
        title: Util.L("OrderType"),
        width: 150,
        key: "orderTypeId",
        render: (h: any, params: any) => {
          if (_.isNil(params.row.orderType)) return "";
          return h("span", params.row.orderType.name);
        },
      },
      {
        title: `${Util.L("Qty")} (${this.sumGiftOrderQty})`,
        key: "qty",
        width: 120,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.qty));
        },
      },
      {
        title: `${Util.L("SoQty")} (${this.sumGiftSoQty})`,
        key: "soQty",
        width: 120,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.soQty));
        },
      },
      {
        title: `${Util.L("HandoverQty")} (${this.sumGiftHandoverQty})`,
        key: "handoverQty",
        width: 120,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.handoverQty));
        },
      },
      {
        title: Util.L("Note"),
        key: "note",
        width: 120,
      },
    ];
  }
  get lineColumns() {
    return [
      ...this.renderLineColumn(),
      {
        title: Util.L("Sku"),
        width: 150,
        key: "product.sku",
        render: (h: any, params: any) => {
          return h("span", params.row.product.sku);
        },
      },
      {
        title: Util.L("ProductName"),
        width: 250,
        key: "product.name",
        render: (h: any, params: any) => {
          return h("span", params.row.product.name);
        },
      },
      {
        title: Util.L("ModelSku"),
        width: 120,
        key: "modelSKU",
      },
      {
        title: Util.L("ExportBrandName"),
        width: 200,
        key: "exportBrandName",
      },
      {
        title: Util.L("Unit"),
        width: 100,
        key: "product.productUnit.name",
        render: (h: any, params: any) => {
          return h("span", params.row.product.productUnit.name);
        },
      },
      {
        title: Util.L("OrderType"),
        width: 100,
        key: "orderTypeId",
        render: (h: any, params: any) => {
          if (_.isNil(params.row.orderType)) return "";
          return h("span", params.row.orderType.name);
        },
      },
      {
        title: `${Util.L("Qty")} (${this.sumLineOrderQty})`,
        key: "qty",
        width: 120,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.qty));
        },
      },
      {
        title: `${Util.L("SoQty")} (${this.sumLineSoQty})`,
        key: "soQty",
        width: 120,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.soQty));
        },
      },
      {
        title: `${Util.L("HandoverQty")} (${this.sumLineHandoverQty})`,
        key: "handoverQty",
        width: 120,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.toViewNumberString(params.row.handoverQty));
        },
      },
      {
        title: `Thể tích (${Util.formatLocateNumber(this.sumVolumeM3, 6)})`,
        key: "qty",
        width: 120,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.formatLocateNumber(params.row.product.volumeM3 * params.row.qty, 6));
        },
      },
      {
        title: Util.L("DiscountType"),
        key: "discountType",
        width: 100,
        render: (h: any, params: any) => {
          if (_.isNil(params.row.discountType)) return "";
          return h(
            "span",
            Util.L(AppConsts.discountTypePrefix + params.row.discountType)
          );
        },
      },
      {
        title: `${Util.L("Discount")}`,
        slot: "discount",
        width: 220,
      },
      {
        title: Util.L("Note"),
        width: 120,
        key: "note",
      },
    ];
  }
  get historyColumns() {
    return [
      {
        title: Util.L("Order"),
        key: "orderNo",
        width: 50,
      },
      {
        title: Util.L("ActionType"),
        width: 100,
        key: "actionTypeCode",
        render: (h: any, params: any) => {
          return h(
            "span",
            Util.L(
              AppConsts.tableRef.tableSOR.prefix.actionType +
                params.row.actionTypeCode
            )
          );
        },
      },
      {
        title: Util.L("OldStatus"),
        key: "oldStatusCode",
        width: 150,
        render: (h: any, params: any) => {
          if (
            _.isNil(params.row.oldStatusCode) ||
            _.isEmpty(params.row.oldStatusCode)
          )
            return "";
          return h(
            "span",
            Util.L(
              AppConsts.tableRef.tableSOR.prefix.status +
                params.row.oldStatusCode
            )
          );
        },
      },
      {
        title: Util.L("NewStatus"),
        width: 150,
        key: "newStatusCode",
        render: (h: any, params: any) => {
          if (
            _.isNil(params.row.newStatusCode) ||
            _.isEmpty(params.row.newStatusCode)
          )
            return "";
          return h(
            "span",
            Util.L(
              AppConsts.tableRef.tableSOR.prefix.status +
                params.row.newStatusCode
            )
          );
        },
      },
      {
        title: Util.L("Note"),
        key: "note",
      },
      {
        title: Util.L("CreatorUserName"),
        width: 150,
        key: "creatorUserId",
        render: (h: any, params: any) => {
          if (_.isNil(params.row.creatorUser)) return "";
          return h(
            "span",
            `${params.row.creatorUser.userName}-${params.row.creatorUser.name}`
          );
        },
      },
      {
        title: Util.L("CreationTime"),
        key: "creationTime",
        width: 180,
        render: (h: any, params: any) => {
          return h("span", Util.toViewDateString(params.row.creationTime));
        },
      },
    ];
  }
  renderSoColumn() {
    if (this.isClient()) {
      return [
        {
          title: Util.L("Warehouse"),
          key: "warehouseName",
          width: 150,
        },
      ];
    }
    return [];
  }
  salesOrderColumns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 50,
    },
    ...this.renderSoColumn(),
    {
      title: Util.L("SoCode"),
      key: "code",
      width: 150,
    },
    {
      title: Util.L("SoExternalCode"),
      key: "externalCode",
      width: 150,
    },
    {
      title: Util.L("AOGroupCode"),
      key: "aoGroupCode",
      width: 150,
    },
    {
      title: Util.L("Status"),
      key: "statusName",
      width: 120,
    },
    {
      title: Util.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
    {
      title: Util.L("Action"),
      width: 120,
      fixed: "right",
      slot: "action",
      align: "center",
    },
  ];
  deliveryNoteColumns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 50,
    },
    {
      title: Util.L("DeliveryNoteCode"),
      key: "code",
      width: 150,
    },
    {
      title: Util.L("Status"),
      key: "statusText",
      width: 120,
    },
    {
      title: Util.L("Receiver"),
      key: "contactName",
      width: 120,
    },
    {
      title: Util.L("PhoneNumber"),
      key: "contactPhone",
      width: 120,
    },
    {
      title: Util.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", Util.toViewDateString(params.row.creationTime));
      },
    },
    {
      title: Util.L("Action"),
      width: 200,
      fixed: "right",
      slot: "action",
      align: "center",
    },
  ];

  rowDetailClassName(row) {
    if (
      this.saleOrderRequest.statusCode == "PREORDER" &&
      row.qty > row.availableQty
    ) {
      return "table-info-highlight-preorder-row";
    }

    return "";
  }
}
